
 import { lazyLoad } from 'utils/loadable';

 export const AdminHome = lazyLoad(
   () => import('./index'),
   module => module.AdminHome,
 );
 